export default __webpack_public_path__ + "ddac11129c1aeed7f09df59c8edad5f0.png";